var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EE6B4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6062 18.9182C21.7828 18.9168 24.0844 19.1369 24.0844 20.1351C24.0845 21.5623 23.903 22.6237 26.7395 22.9331C29.576 23.2397 29.2102 21.1883 29.2116 19.8065C29.2116 18.2116 25.4841 15.9938 19.6076 15.9937C13.7297 15.995 10.0009 18.2114 10.0009 19.8063C10.0009 21.1895 9.6352 23.2382 12.4731 22.9302C15.3082 22.6223 15.1281 21.5622 15.1281 20.135C15.1281 19.1368 17.4283 18.9182 19.6062 18.9182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeave);
export default __webpack_public_path__ + "static/media/icon_leave.97fb167c3ddfbe2e1a0ae42915f0f18a.svg";
export { ForwardRef as ReactComponent };